import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    getPasswordPolicieNameService,
    localStorageService,
} from '../../../../infrastructure/services';
import TabHeader from './TabHeader';
import TabSeccion from './TabSeccion';
import { PasswordPolicie } from '../../../../domain/shared';
import { Company } from '../../../../domain/companies';
import { LocalStorage_keys } from '../../../../main/constants';
import { AppContext } from '../../../../main/context/Provider';

export interface ProfileContainerProps {
    changeConfirmPassword: (e: ChangeEvent<HTMLInputElement>) => void;
    changeNewPassword: (e: ChangeEvent<HTMLInputElement>) => void;
    changeCurrentPassword: (e: ChangeEvent<HTMLInputElement>) => void;
    savePassword: () => void;
    passwordPoliciesList: PasswordPolicie[];
    // companiesList: Company[];
    isChangeSuccessfully: boolean;
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
    isSendChange: boolean;
}

const ProfileContainer = ({
    changeConfirmPassword,
    changeNewPassword,
    changeCurrentPassword,
    savePassword,
    passwordPoliciesList,
    isChangeSuccessfully,
    currentPassword,
    newPassword,
    confirmPassword,
    isSendChange,
}: ProfileContainerProps) => {
    const { langResources, userInfo } = useContext(AppContext);

    const [activeNav, setActiveNav] = useState<number>(1);

    return (
        <div className='col-lg-9'>
            <div className='card p-3 mb-3 card'>
                <div className='card-header'>
                    <ul
                        role='tablist'
                        className='nav-tabs-custom rounded card-header-tabs border-bottom-0 nav'
                        id={'profile-tabs'}
                    >
                        <TabHeader
                            currentActiveNav={activeNav}
                            activeNavValue={1}
                            setActiveNav={setActiveNav}
                            text={
                                langResources['profile.page'][
                                    'personal.information.title'
                                ]
                            }
                        />

                        <TabHeader
                            currentActiveNav={activeNav}
                            activeNavValue={2}
                            setActiveNav={setActiveNav}
                            text={
                                langResources['profile.page'][
                                    'change.password.title'
                                ]
                            }
                        />
                    </ul>
                </div>

                <div className='card-body p-3'>
                    <div className='tab-content'>
                        <TabSeccion activeNavValue={1} currentActiveNav={activeNav}>
                            <form className='row'>
                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            {
                                                langResources['profile.page'][
                                                    'personal.information.fullname'
                                                ]
                                            }
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={`${userInfo.firstName} ${userInfo.middleName} ${userInfo.lastName} ${userInfo.surname}`}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Tipo de documento
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.documentTypeName}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Numero de documento
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.documentNumber}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Ciudad
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.cityName}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Cargo
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.positionName}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Grupo
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.groupName}
                                        />
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Correo Electrónico
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.email}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Celular
                                        </label>
                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.cellphoneNumber}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Teléfono
                                        </label>

                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.phoneNumber}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            {
                                                langResources['profile.page'][
                                                    'personal.information.address'
                                                ]
                                            }
                                        </label>

                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.address}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label'>
                                            Fecha de Nacimiento
                                        </label>

                                        <input
                                            readOnly
                                            type='text'
                                            className='form-control form-control text-black'
                                            value={userInfo.birthDate}
                                        />
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                    <div className=''>
                                        <label className='form-label form-label '>
                                            {
                                                langResources['profile.page'][
                                                    'personal.information.user.active'
                                                ]
                                            }
                                        </label>

                                        <div
                                            className={`mt-2 form-check form-switch text-center checked-custom text-primary2 `}
                                        >
                                            <input
                                                role='switch'
                                                name='isPaid'
                                                defaultChecked={userInfo.isActive}
                                                type='checkbox'
                                                className={`form-check-input form-check-input`}
                                                readOnly
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </TabSeccion>

                        <TabSeccion activeNavValue={2} currentActiveNav={activeNav}>
                            <form action=''>
                                <div className='row g-2'>
                                    <div className='col-12 col-lg-4'>
                                        <div>
                                            <label
                                                htmlFor='changeCurrentPassword'
                                                className='form-label form-label'
                                            >
                                                {
                                                    langResources['profile.page'][
                                                        'change.password.old.password.label'
                                                    ]
                                                }
                                                *
                                            </label>
                                            <input
                                                onChange={changeCurrentPassword}
                                                id='currentPassword'
                                                placeholder={
                                                    langResources['profile.page'][
                                                        'change.password.old.password.placeholder'
                                                    ]
                                                }
                                                type='password'
                                                className='form-control form-control'
                                            />
                                        </div>
                                    </div>

                                    <div className='col-12 col-lg-4'>
                                        <div>
                                            <label
                                                htmlFor='newpasswordInput'
                                                className='form-label form-label'
                                            >
                                                {
                                                    langResources['profile.page'][
                                                        'change.password.new.password.label'
                                                    ]
                                                }
                                            </label>
                                            <input
                                                onChange={changeNewPassword}
                                                id='newpasswordInput'
                                                placeholder={
                                                    langResources['profile.page'][
                                                        'change.password.old.password.placeholder'
                                                    ]
                                                }
                                                type='password'
                                                className='form-control form-control'
                                            />
                                        </div>
                                    </div>

                                    <div className='col-12 col-lg-4'>
                                        <div>
                                            <label
                                                htmlFor='confirmpasswordInput'
                                                className='form-label form-label '
                                            >
                                                {
                                                    langResources['profile.page'][
                                                        'change.password.confirm.password.label'
                                                    ]
                                                }
                                            </label>
                                            <input
                                                onChange={changeConfirmPassword}
                                                id='confirmpasswordInput'
                                                placeholder={
                                                    langResources['profile.page'][
                                                        'change.password.confirm.password.label'
                                                    ]
                                                }
                                                type='password'
                                                className='form-control form-control'
                                                disabled={newPassword === ''}
                                            />
                                        </div>
                                    </div>

                                    <div className='col-12 pt-3'>
                                        <div className='row'>
                                            <div className='col-12 col-lg-8'>
                                                {passwordPoliciesList.map(
                                                    (pp, index) =>
                                                        !pp.status && (
                                                            <li
                                                                className='text-danger'
                                                                key={pp.title}
                                                            >
                                                                {getPasswordPolicieNameService(
                                                                    pp.title,
                                                                    langResources
                                                                )}
                                                            </li>
                                                        )
                                                )}

                                                {isChangeSuccessfully && (
                                                    <p className='text-success fa-4'>
                                                        {
                                                            langResources[
                                                                'profile.page'
                                                            ][
                                                                'save.change.successfully'
                                                            ]
                                                        }
                                                    </p>
                                                )}
                                            </div>

                                            <div className='col-12 col-lg-4 d-flex justify-content-end align-self-end'>
                                                <button
                                                    style={{
                                                        height: 40,
                                                    }}
                                                    type='button'
                                                    className={`btn btn-primary`}
                                                    disabled={
                                                        newPassword === '' ||
                                                        currentPassword === '' ||
                                                        confirmPassword === '' ||
                                                        isSendChange === false
                                                    }
                                                    onClick={savePassword}
                                                >
                                                    {
                                                        langResources[
                                                            'profile.page'
                                                        ]['btn.save.changes']
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </TabSeccion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileContainer;
